var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0822 16.8629L27.7724 14.2871C28.578 11.2803 28.9809 9.7769 28.6775 8.47587C28.438 7.44859 27.8992 6.51541 27.1293 5.79434C26.1543 4.88111 24.6509 4.47827 21.6441 3.67261C18.6373 2.86695 17.134 2.46412 15.8329 2.76747C14.8056 3.007 13.8725 3.54577 13.1514 4.31566C12.3695 5.15048 11.9618 6.3726 11.355 8.59399C11.2531 8.96707 11.1456 9.36834 11.0297 9.8007L11.0297 9.80087L10.3395 12.3767C9.53382 15.3834 9.13099 16.8868 9.43434 18.1879C9.67387 19.2151 10.2126 20.1483 10.9825 20.8694C11.9576 21.7826 13.461 22.1855 16.4677 22.9911C19.1779 23.7173 20.6666 24.1162 21.8867 23.9657C22.0202 23.9492 22.1506 23.9262 22.2789 23.8963C23.3062 23.6567 24.2394 23.118 24.9605 22.3481C25.8737 21.373 26.2765 19.8696 27.0822 16.8629Z",
    stroke: "#516609",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8866 23.9655C21.6086 24.8168 21.1198 25.5869 20.4626 26.2025C19.4875 27.1157 17.9841 27.5186 14.9774 28.3242C11.9706 29.1299 10.4672 29.5327 9.16618 29.2294C8.1389 28.9898 7.20572 28.4511 6.48464 27.6812C5.57141 26.7061 5.16858 25.2027 4.36292 22.196L3.67273 19.6202C2.86707 16.6134 2.46424 15.11 2.7676 13.809C3.00712 12.7817 3.5459 11.8485 4.31578 11.1274C5.29083 10.2142 6.79422 9.81137 9.80099 9.00571C10.3698 8.85328 10.8849 8.71528 11.3549 8.59375",
    stroke: "#516609",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7025 13.3335L22.142 15.059",
    stroke: "#516609",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 17.1968L18.5303 18.2321",
    stroke: "#516609",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.3b880c5355a5584610bf0e72224e3a35.svg";
export { ForwardRef as ReactComponent };